import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import Cookies from 'universal-cookie'
import { isEmpty } from 'lodash'
import { cartItem } from '../../../redux-saga/User/Login/Reducer'
import Card from '../../../components/Mobile/ProductCard/Card'
import style from './index.module.css'
import { PARAMS } from '../../../utils/User/constants/routingConfig/routeDetails'
import { getPesticideByRequest } from '../../../redux-saga/User/PesticideBy/Reducer'
import PesticidePreviewComponent from '../../../components/Mobile/PesticidePreview'
import SpinLoader from '../../../components/Mobile/Loader'
import { isAddedInCart } from '../../../utils/User/helper/functions'

const PesticidePreview = ({ additionalClass }) => {
  const params = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { pesticides, fetching } = useSelector((state) => state.pesticidesBy)

  useEffect(() => {
    if (!isEmpty(params)) {
      dispatch(getPesticideByRequest([ PARAMS.id, params[ PARAMS.pesticideId ] ]))
    }
  }, [])
  return (
    <>
      <div className='container-fluid'>
        <div className={ `${ additionalClass } ${ style.flexClass }` }>
          { fetching
            ? <SpinLoader />
            : pesticides.length && pesticides.map((pesticide) => (
              <PesticidePreviewComponent
                key={ pesticide.id }
                pesticide={ pesticide }
                history={ history }
                isAdded={ isAddedInCart(pesticide) }
                dispatch={ dispatch }
              />
            ))}
        </div>
      </div>
    </>
  )
}

export default PesticidePreview

PesticidePreview.defaultProps = {
  additionalClass: '',
}

PesticidePreview.propTypes = {
  // pesticides: PropTypes.arrayOf.isRequired,
  additionalClass: PropTypes.string,
}
